/**
 * Dismisses desktop hotel search overlays when the controls become sticky.
 * GC owns their state, so reuse its existing dismissal handlers without querying
 * its internal DOM. Events originate on the outer wrapper, outside each overlay,
 * and bubble to the document listeners.
 */
const dismissSearchControlsOverlays = (container: HTMLElement) => {
  const { ownerDocument } = container;
  // Fall back for environments without PointerEvent, including JSDOM.
  const PointerDownEvent =
    ownerDocument.defaultView?.PointerEvent ?? MouseEvent;

  // Guests uses Backpack's pointerdown outside-press handler. detail: 1 marks a
  // mouse press, preventing the virtual-click path from restoring trigger focus.
  container.dispatchEvent(
    new PointerDownEvent('pointerdown', { bubbles: true, detail: 1 }),
  );

  // The double calendar listens for mousedown. Dispatching pointerdown alone
  // does not generate the follow-up mouse events that a real interaction would.
  container.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));

  // Destination dismisses suggestions on blur. Synthetic events do not move
  // focus, so blur explicitly, leaving focus elsewhere on the page untouched.
  const { activeElement } = ownerDocument;
  if (
    activeElement instanceof HTMLElement &&
    container.contains(activeElement)
  ) {
    activeElement.blur();
  }
};

export default dismissSearchControlsOverlays;
